<ng-container [formGroup]="formCtrl">
  <div class="form-group mb-16 mr-32">
    <div class="form-control grow">
      <label class="field-label bd-field-label">Base URL</label>
      <input
        (blur)="formatUrlField()"
        class="bd-text-input tall grow"
        formControlName="baseUrl"
        required
      />
    </div>
  </div>
  <div class="form-group mr-32">
    <div class="form-control column-limited" [class.oauth]="isAuthType(AuthorizationType.OAuth2)">
      <label class="field-label bd-field-label">Authorization Type</label>
      <blaze-select
        [allowNone]="false"
        [options]="apiAuthorizationTypes"
        [showNoneOption]="false"
        [showSelection]="true"
        class="select-input tall"
        formControlName="apiAuthorizationType"
      />
    </div>

    @if (isAuthType(AuthorizationType.Basic)) {
      <ng-container formGroupName="basicAuthorization">
        <div class="form-control ml-8 credentials">
          <input
            autocomplete="off"
            class="bd-text-input tall"
            formControlName="username"
            placeholder="Username"
            required
          />
        </div>
        <div class="form-control ml-8 credentials">
          <input
            autocomplete="off"
            class="bd-text-input tall"
            formControlName="password"
            placeholder="Password"
            required
            type="password"
            blazePasswordVisibilityToggle
          />
        </div>
      </ng-container>
    }

    @if (isAuthType(AuthorizationType.Bearer)) {
      <ng-container formGroupName="bearerTokenAuthorization">
        <div class="form-control ml-8 grow">
          <input
            autocomplete="off"
            class="bd-text-input tall"
            formControlName="token"
            placeholder="Token"
            required
          />
        </div>
      </ng-container>
    }

    @if (isAuthType(AuthorizationType.OAuth2)) {
      <ng-container formGroupName="oAuth2Authorization">
        <div class="form-control column-limited oauth-flow">
          <label class="field-label bd-field-label">Grant Type</label>
          <blaze-select
            [allowNone]="false"
            [options]="oauthFlowTypes"
            [showNoneOption]="false"
            [showSelection]="true"
            class="select-input tall"
            formControlName="oAuth2FlowType"
          />
        </div>
        @if (oAuthAuthorized$ | async) {
          <div class="form-control ml-8 grow">
            <div class="field-oauth-authorized">
              <mat-icon svgIcon="icon_check_24" class="success-icon" />
              <span class="font-bold uppercase mx-8">OAuth Authorized</span>
              <button
                (click)="showEditOAuthForm()"
                blazeButton="secondary"
                class="edit-btn"
                type="button"
                >Edit</button
              >
            </div>
          </div>
        } @else {
          <div class="form-control ml-8 grow">
            <label class="field-label bd-field-label">Callback URL</label>
            <div class="flex items-center">
              <input
                class="readonly-input bd-text-input tall grow"
                formControlName="redirectUrl"
                readonly
                required
              />
              <button
                #copyLinkTooltip="blazeTooltip"
                (click)="copyToClipboard$$.next(oAuth2RedirectUrl)"
                (mouseenter)="$event.stopImmediatePropagation()"
                blazeButton="primary-outline"
                blazeTooltip=""
                class="field-action-btn"
                matTooltipPosition="above"
                type="button"
                >Copy Link</button
              >
            </div>
          </div>
        }
      </ng-container>
    }
  </div>

  @if (isAuthType(AuthorizationType.OAuth2) && (oAuthAuthorized$ | async) === false) {
    <blaze-oauth-authorization-form [formCtrl]="oAuth2Ctrl" />
  }

  <blaze-parameters-list label="Headers" [formCtrl]="headersCtrl" [parameters]="common.headers" />
</ng-container>
